export enum Theme {
  GLOBAL = 'global',
}